import React, { useEffect, useState } from "react";
import { SVGIcons, ImgIcons } from "../../Helpers/Common";
import { Link } from "react-router-dom";

var SVGIcon = "";
SVGIcons().then((resultData) => (SVGIcon = resultData));

var ImageData = "";
ImgIcons().then((result) => (ImageData = result));
export const FooterMobile = () => {
    return (
        <>
            <footer className="dD-none">
                <section className="mb-0">
                    {/* <div className="footer-nav"> */}
                    <div className="footer-navArea">
                        <div className="footer-mobile">
                            <div className="footer-navCol">
                                <ul>
                                    <li>
                                        {" "}
                                        <h4>Company</h4>{" "}
                                    </li>
                                    <li>
                                        {" "}
                                        <Link to="/about-us" className="footer-text">About Us</Link>
                                    </li>
                                    <li>
                                        {" "}
                                        <Link to="/news" className="footer-text">News</Link>
                                    </li>
                                </ul>
                            </div>
                            <div className="footer-navCol">
                                <ul>
                                    <li>
                                        {" "}
                                        <h4>Support</h4>{" "}
                                    </li>
                                    <li>
                                        {" "}
                                        <Link to="/contact-us" className="footer-text">Contact Us</Link>
                                    </li>
                                    <li>
                                        {" "}
                                        <Link to="/help-support" className="footer-text">FAQ’s</Link>{" "}
                                    </li>
                                </ul>
                            </div>
                            <div className="footer-navCol">
                                <ul>
                                    <li>
                                        {" "}
                                        <h4>Legal</h4>{" "}
                                    </li>
                                    <li>
                                        {" "}
                                        <Link to="/terms" className="footer-text">Terms Of Use</Link>{" "}
                                    </li>
                                    <li>
                                        {" "}
                                        <Link to="/privacy" className="footer-text">Privacy Policy</Link>{" "}
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="footer-navCol soc">
                            <div className="footer-socialIcons">
                                <ul>
                                    <li>
                                        {" "}
                                        <h4>
                                            {" "}
                                            <>Connect With Us On</>
                                        </h4>{" "}
                                    </li>
                                </ul>
                                <ul className="social">
                                    <li>
                                        {" "}
                                        <a
                                            href="https://www.facebook.com/onetribedocubay/"
                                            target="_blank" rel="noopener noreferrer">
                                            <img src={SVGIcon["fb.svg"]} alt="fb" />
                                        </a>{" "}
                                    </li>
                                    <li>
                                        {" "}
                                        <a
                                            href="https://www.instagram.com/onetribedocubay/"
                                            target="blank" rel="noreferrer"
                                        >
                                            <img src={SVGIcon["insta.svg"]} alt="Insta" />
                                        </a>{" "}
                                    </li>
                                    <li>
                                        {" "}
                                        <a
                                            href="https://www.youtube.com/channel/UC9Luu8UOg1lbrOnLWoizdAQ"
                                            target="blank" rel="noreferrer"
                                        >
                                            <img src={SVGIcon["tube.svg"]} alt="You Tube" />
                                        </a>{" "}
                                    </li>
                                    <li>
                                        {" "}
                                        <a
                                            href="http://linkedin.com/company/docubay/"
                                            target="blank" rel="noreferrer"
                                        >
                                            <img src={SVGIcon["in.svg"]} alt="In" />
                                        </a>{" "}
                                    </li>
                                    <li>
                                        {" "}
                                        <a href="https://twitter.com/onetribedocubay" target="blank" rel="noreferrer">
                                            <img src={ImageData["twitter.png"]} alt="Tw" />
                                        </a>{" "}
                                    </li>
                                </ul>
                            </div>
                            {/* <ul>
                <li>
                  <a
                    href="https://wa.me/919738274274?text=Hi"
                    target="_blank"
                    className="social-2"
                  >
                    <img
                      src={SVGIcon["whatsapp1.svg"]}
                      alt="whatsapp"
                      className="wp-img"
                    />{" "}
                    <span>Support</span>{" "}
                  </a>{" "}
                </li>
              </ul> */}
                        </div>
                    </div>
                    {/* </div> */}
                </section>
                <section className="mb-0">
                    {/* <div className="footer-copyR"> */}
                    <div className="footer-copyRArea">
                        <div className="footer-copyLeft">
                            &copy; {new Date().getFullYear()} DocuBay Media Private Limited. All Rights Reserved.
                        </div>
                    </div>
                    <div className="footer-copyRArea">
                        <div className="footer-copyLeft footer-in10logo">
                            An<img
                                src={ImageData["in10log.png"]}
                                className="In10logo"
                                alt="In10"
                            />Venture
                        </div>
                    </div>
                    {/* </div> */}
                </section>
            </footer>
        </>
    );
};